import React from 'react';
import { Button } from '../ui/button';
import { Lock, Check, Sparkles } from 'lucide-react';

const RecommendationScreen = ({ recommendation, onShowPrice }) => {
  const { package: packageName, tier, reasons, features } = recommendation;

  const tierColors = {
    starter: 'from-cyan-500 to-blue-500',
    scaling: 'from-blue-500 to-indigo-500',
    enterprise: 'from-indigo-500 to-purple-500',
  };

  return (
    <div className="bg-gray-800/50 border border-gray-700 rounded-2xl p-8">
      <div className="text-center mb-8">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-cyan-500/10 border border-cyan-500/30 rounded-full mb-4">
          <Sparkles className="w-4 h-4 text-cyan-400" />
          <span className="text-cyan-400 font-medium text-sm">Your recommended plan</span>
        </div>
        <h2 className="text-3xl font-bold text-white mb-2">{packageName}</h2>
        <div className={`inline-block px-4 py-1 rounded-full bg-gradient-to-r ${tierColors[tier]} text-white text-sm font-medium`}>
          {tier === 'enterprise' ? 'Custom Pricing' : tier === 'scaling' ? '$15/user/month' : '$20/user/month'}
        </div>
      </div>

      <div className="mb-8">
        <h3 className="text-lg font-semibold text-white mb-4">Why this plan?</h3>
        <div className="space-y-3">
          {reasons.map((reason, index) => (
            <div key={index} className="flex items-start gap-3">
              <Check className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" />
              <span className="text-gray-300">{reason}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="mb-8">
        <h3 className="text-lg font-semibold text-white mb-4">What's included:</h3>
        <div className="space-y-2">
          {features.map((feature, index) => (
            <div key={index} className="flex items-center gap-3">
              <div className="w-2 h-2 bg-cyan-400 rounded-full flex-shrink-0" />
              <span className="text-gray-300">{feature}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Locked pricing area */}
      <div className="relative mb-8">
        <div className="bg-gray-900/50 border-2 border-gray-700 rounded-xl p-8 blur-sm">
          <div className="text-center">
            <div className="text-2xl font-bold text-white mb-2">Your estimated monthly cost</div>
            <div className="text-gray-400">Based on your team size</div>
          </div>
        </div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="bg-gray-800 border-2 border-cyan-500 rounded-xl p-5 text-center shadow-lg shadow-cyan-500/20">
            <Lock className="w-8 h-8 text-cyan-400 mx-auto mb-2" />
            <div className="text-white font-semibold">See your exact pricing</div>
            <div className="text-gray-400 text-sm mt-1">Just a few quick details</div>
          </div>
        </div>
      </div>

      <Button
        onClick={onShowPrice}
        className="w-full h-14 bg-cyan-600 hover:bg-cyan-700 text-lg font-semibold"
        data-testid="show-price-btn"
      >
        Show My Price
      </Button>
    </div>
  );
};

export default RecommendationScreen;
